import { Tab } from '../../../../../views/active-orders';

export default {
  title: 'Panou restaurant',
  tabs: {
    [Tab.OngoingOrders]: 'Pregătește acum',
    [Tab.FutureOrders]: 'Viitoare',
    [Tab.CompleteOrders]: 'Finalizate',
  },
  buttons: {
    order_history: 'Istoric comenzi',
  },
  feedback: {
    future_orders_alert: '⚠️ Nu pregătiți încă – vă vom anunța când trebuie să începeți.',
  },
};
